import React from 'react';
import PropTypes from 'prop-types';
import useReportingStrings from '../utils/useReportingStrings';

// Change of a headline figure against its baseline (spec FR-029 to FR-031). Meaning never relies
// on colour alone: every state has an arrow and a sign, and the compared dates are shown.
const STATES = {
  up: { arrow: '▲', sign: '+', color: '#2b8000' },
  down: { arrow: '▼', sign: '−', color: '#c12335' },
  flat: { arrow: '■', sign: '', color: '#555555' }
};

export const formatChange = (metric, strings) => {
  if (!metric || metric.change_label === 'n/m' || metric.change_percent === null || metric.change_percent === undefined) {
    return metric && metric.small_base ? strings.baselineSmallBase : strings.baselineNotMeaningful;
  }
  const state = STATES[metric.change_label] || STATES.flat;
  const amount = Math.abs(metric.change_percent).toFixed(1);
  const suffix = metric.unit === 'points' ? ` ${strings.baselinePointsSuffix}` : '%';
  return `${state.arrow} ${state.sign}${amount}${suffix}`;
};

const BaselineBadge = ({ metric, baseline }) => {
  const strings = useReportingStrings();
  if (!metric) return null;

  const state = STATES[metric.change_label];
  const text = formatChange(metric, strings);
  let range = '';
  if (baseline && baseline.start) {
    range = baseline.start === baseline.end ? baseline.start : `${baseline.start} – ${baseline.end}`;
  }
  const spoken = state ? strings[`baseline${metric.change_label[0].toUpperCase()}${metric.change_label.slice(1)}`] : '';

  return (
    <div data-testid="baseline-badge" style={{ fontSize: '0.75rem', marginTop: '0.25rem' }}>
      <span
        data-testid="baseline-change"
        aria-label={spoken ? `${spoken} ${text}` : text}
        style={{ fontWeight: 600, color: state ? state.color : '#555555' }}
      >
        {text}
      </span>
      {range && (
        <span data-testid="baseline-range" style={{ color: '#666666', marginLeft: '0.5rem' }}>
          {`${strings.baselineVs} ${range}`}
        </span>
      )}
    </div>
  );
};

BaselineBadge.propTypes = {
  metric: PropTypes.shape({
    change_label: PropTypes.string,
    change_percent: PropTypes.number,
    unit: PropTypes.string,
    small_base: PropTypes.bool
  }),
  baseline: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
    label: PropTypes.string
  })
};

BaselineBadge.defaultProps = {
  metric: null,
  baseline: null
};

export default BaselineBadge;
